<template>
    <div class="navbar">
        <img src="/games/static/clicktestcps-games-logofr-admin.png" alt="Administration" draggable="false">
        
        <ul>
            <li><router-link to="/private170621/administration/panel"><i class="fas fa-home"></i> Accueil</router-link></li>
            <li class="sub-menu"><a><i class="fas fa-gamepad"></i> Jeux</a>
                <ul>
                    <li><router-link to="/private170621/administration/addGame">Ajouter</router-link></li>
                    <li><router-link to="/private170621/administration/editGames">Modifier</router-link></li>
                    <li><router-link to="/private170621/administration/featureGames">Mettre en avant</router-link></li>
                </ul>
            </li>
            <li><router-link to="/private170621/administration/editSlider"><i class="fas fa-images"></i> Configurer le slider</router-link></li>
            <li><router-link to="/private170621/administration/editComments"><i class="fas fa-comment-dots"></i> Commentaires publiés</router-link></li>

            <li class="sub-menu"><a><i class="fas fa-users-cog"></i> Membres</a>
                <ul>
                    <li><router-link to="/private170621/administration/addAccount">Ajouter</router-link></li>
                    <li><router-link to="/private170621/administration/editAccounts">Modifier</router-link></li>
                </ul>
            </li>

            <br>
            
            <li><a href="#" @click.prevent="logout"><i class="fas fa-power-off"></i> Déconnexion</a></li>
        </ul>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1"
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=logout", formData, { withCredentials: true })
            .then((response) => {
                if(response.data) {
                    this.$router.replace({ name: 'adminConnection' });
                }
            });
        }
    }
}
</script>

<style scoped src="@/assets/admin.css">
</style>
